import { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  let [authUser, setAuthUser] = useState(() =>
    localStorage.getItem('authTokens')
      ? jwtDecode(JSON.parse(localStorage.getItem('authTokens')).access)
      : null,
  );
  let [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem('authTokens')
      ? JSON.parse(localStorage.getItem('authTokens'))
      : null,
  );

  let loginUser = async (e) => {
    e.preventDefault();
    const response = await fetch(process.env.REACT_APP_API_ACCESS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: e.target.username.value,
        password: e.target.password.value,
      }),
    });

    let data = await response.json();

    if (response.status !== 200) {
      alert("I didn't like that. Try again.");
      return;
    }

    if (data) {
      localStorage.setItem('authTokens', JSON.stringify(data));
      setAuthTokens(data);
      setAuthUser(jwtDecode(data.access));
      navigate('/');
    } else {
      alert("Somethings wrong, couldn't login!");
    }
  };

  let logoutUser = (e) => {
    if (e) e.preventDefault();
    localStorage.removeItem('authTokens');
    setAuthTokens(null);
    setAuthUser(null);
    navigate('/login');
  };

  const updateToken = async () => {
    const response = await fetch(process.env.REACT_APP_API_REFRESH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh: authTokens?.refresh }),
    });
    const data = await response.json();

    if (response.status === 200) {
      setAuthTokens(data);
      setAuthUser(jwtDecode(data.access));
      localStorage.setItem('authTokens', JSON.stringify(data));
    } else {
      logoutUser();
    }
  };

  const tryRefreshToken = async () => {
    if (!authTokens) return null;

    const accessExp = jwtDecode(authTokens.access).exp * 1000;

    if (Date.now() > accessExp) {
      return await updateToken();
    }
    return authTokens;
  };

  const authFetch = async (url, options = {}) => {
    const tokens = await tryRefreshToken();

    if (!tokens) {
      logoutUser();
      return Promise.reject(new Error('No auth token'));
    }
    const headers = new Headers(options.headers || {});
    headers.set('Authorization', `Bearer ${tokens.access}`);
    options.headers = headers;

    return fetch(url, options);
  };

  useEffect(() => {
    const REFRESH_INTERVAL = 1000 * 60 * 4;
    let interval = setInterval(() => {
      if (authTokens) {
        updateToken();
      }
    }, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [authTokens]);

  let contextData = {
    user: authUser,
    authTokens: authTokens,
    loginUser: loginUser,
    logoutUser: logoutUser,
    authFetch: authFetch,
  };

  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};
